import { SEARCH_TEAM_EVENTS, CLEAR_SEARCH_TEAM_EVENTS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${SEARCH_TEAM_EVENTS}_SUCCESS`) {
    return action.payload;
  }
  if (action.type === CLEAR_SEARCH_TEAM_EVENTS) return [];

  return state;
};
